import Form from "../components/Form"

function Register() {
    return <Form route="user/register/" method="register" />
}

export default Register